import { render, staticRenderFns } from "./LocationForm.vue?vue&type=template&id=3f561c9f&scoped=true&"
import script from "./LocationForm.vue?vue&type=script&lang=js&"
export * from "./LocationForm.vue?vue&type=script&lang=js&"
import style0 from "./LocationForm.vue?vue&type=style&index=0&id=3f561c9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f561c9f",
  null
  
)

export default component.exports